import { WelfareProvider } from '@/dataAccess/rest/measurement/measurement.types';

export interface WelfareWidgetConfig {
  id: string;
  name: string;
}

export enum WelfareScoreTrend {
  Up = 'Up',
  Down = 'Down',
  Flat = 'Flat',
}

export enum WelfareSeverityGroup {
  High = 'High',
  Moderate = 'Moderate',
  Low = 'Low',
}

export enum WelfareSeverity {
  Green = 'green',
  Yellow = 'yellow',
  Orange = 'orange',
  Red = 'red',
}

export type IndicatorSeverityConfig = {
  /** Red threshold - evaluated first (most severe) */
  red: number;
  /** Yellow threshold - evaluated if red doesn't match */
  yellow: number;
  /** Green is the default if neither red nor yellow match */
};

export interface WelfareIndicatorWidgetConfig {
  id: string;
  name: string;
  welfareType?: WelfareProvider;
}

export enum WelfareIndicatorView {
  Chart = 'chart',
  Table = 'table',
}

export type WelfareHistoryWeeks = 0 | 1 | 4 | 7 | 10;
